import {
	Box,
	CSSProperties,
	ElementSizeVariants,
	Tooltip as TooltipCF,
	useDevice,
} from '@bcp-nextgen-dx-component-factory/design-system';

export interface AppTooltipProps {
	title?: string;
	description?: string;
	size?: ElementSizeVariants;
	styles?: CSSProperties;
}

export const AppTooltip = ({ title, description, size = 'xSmall', styles }: AppTooltipProps) => {
	const { deviceFamily } = useDevice();

	const triggerMode = deviceFamily === 'laptop' ? 'hover' : 'press';

	return (
		<Box styles={{ display: 'inline-block', ...styles }}>
			<TooltipCF
				content={
					<TooltipCF.Container>
						<TooltipCF.Title>{title}</TooltipCF.Title>
						<TooltipCF.Description>{description}</TooltipCF.Description>
					</TooltipCF.Container>
				}
				configs={{
					onContextChange: 'close',
				}}
				triggerMode={triggerMode}
			>
				<TooltipCF.Trigger size={size} />
			</TooltipCF>
		</Box>
	);
};
